import React, {useState} from 'react';
import {
  Flex,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Slider,
} from '@chakra-ui/react';
import _ from 'lodash';

export const NumberControl = ({name, value, onChange, min, max, precision = 2, step}) => {
  const [formVal, setFormVal] = useState(value);

  return (
    <Flex>
      <NumberInput
        max={Infinity}
        maxWidth="10em"
        min={-Infinity}
        onChange={setFormVal}
        onBlur={() => onChange(parseFloat(formVal))}
        precision={precision}
        step={step || 0.1}
        value={formVal}
      >
        <NumberInputField/>
        <NumberInputStepper>
          <NumberIncrementStepper/>
          <NumberDecrementStepper/>
        </NumberInputStepper>
      </NumberInput>

      {_.isNumber(min) && _.isNumber(max) && (
        <Slider
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          step={step || Math.abs(max - min) / 10}
          width="10em"
        />
      )}
    </Flex>
  );
};
export const StringControl = ({name, value, onChange}) => {
  const [formVal, setFormVal] = useState(value);

  return (
    <Flex>
      <Input
        value={formVal}
        onBlur={() => onChange(formVal)}
        onChange={(e) => setFormVal(e.target.value)}
      />
    </Flex>
  );
};

export const SelectControl = ({name, value, onChange, options = []}) => {
  return (
    <Flex>
      <Select
        value={String(value)}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {options.map(({label, value}) => (
          <option key={label} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </Flex>
  );
};
